import * as rd from '@devexperts/remote-data-ts'
import { Alert } from '@spiaggeit/spit-ui'
import { Trans, useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

import { licenseSlice } from '@/store/licenseSlice'
import { ExclamationMark } from '../../assets/icons/ExclamationMark'
import { useAppSelector } from '../../hooks/store'
import { BookingAvailabilityError } from '../../models/bookingAvailability'
import {
  BookingAvailability,
  bookingAvailabilitySlice,
} from '../../store/bookingAvailabilitySlice'

//E. la logica di queste alert è da rifare, infatti la doc dice:
// "vi sono definiti delle diciture che rappresentano i vari errore che l’utente può riscontrare durante
// la navigazione, anche in questo punto sarebbe da non passarli più in queryString tra una rotta e l’altra."
export function InsertPeriodAlerts() {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const license = useAppSelector(licenseSlice.selectors.license)
  const isBookingEnabled = useAppSelector(
    licenseSlice.selectors.isBookingEnabled
  )
  const bookingAvailabilityErrorCode = useAppSelector(
    bookingAvailabilitySlice.selectors.errorCode
  )
  const bookingAvailabilityErrorSubstitutions = useAppSelector(
    bookingAvailabilitySlice.selectors.errorSubstitutions
  )
  const bookingAvailabilty = useAppSelector(
    bookingAvailabilitySlice.selectors.self
  )
  const areSpotsAvailable = useAppSelector(
    bookingAvailabilitySlice.selectors.areSpotsAvailable
  )
  const areTicketsAvailable = useAppSelector(
    bookingAvailabilitySlice.selectors.areTicketsAvailable
  )
  // const isSoldOut = useAppSelector(bookingAvailabilitySlice.selectors.isSoldOut)
  const isSoldOut =
    rd.isSuccess(bookingAvailabilty) &&
    bookingAvailabilty.value.type !== BookingAvailability.NONE &&
    !areTicketsAvailable &&
    !areSpotsAvailable

  if (
    bookingAvailabilityErrorCode === BookingAvailabilityError.PERIOD_NOT_FOUND
  ) {
    return
  }

  const hasError =
    bookingAvailabilityErrorCode !== null ||
    isSoldOut ||
    searchParams.has('createCartError')

  if (!license || !hasError) {
    return null
  }

  if (!isBookingEnabled) {
    return (
      <AlertWrapper
        intent="critical"
        message={t('insertPeriod.alerts.bookingDisabled')}
      />
    )
  }
  if (bookingAvailabilityErrorCode === BookingAvailabilityError.PAST_DATE) {
    return (
      <AlertWrapper
        intent="warning"
        message={t('insertPeriod.alerts.PAST_DATE')}
      />
    )
  }

  if (
    bookingAvailabilityErrorCode ===
    BookingAvailabilityError.BOOKING_AVAILABILITY_MANAGER_EXCEPTION_ERROR_001
  ) {
    return (
      <AlertWrapper
        intent="warning"
        message={
          <Trans
            i18nKey="insertPeriod.alerts.001"
            shouldUnescape
            values={{
              from: bookingAvailabilityErrorSubstitutions?.booking_start_date,
              to: bookingAvailabilityErrorSubstitutions?.booking_end_date,
            }}
          />
        }
      />
    )
  }

  if (
    bookingAvailabilityErrorCode ===
    BookingAvailabilityError.BOOKING_AVAILABILITY_MANAGER_EXCEPTION_ERROR_002
  ) {
    return (
      <AlertWrapper
        intent="warning"
        message={t('insertPeriod.alerts.002', {
          timeLimit: bookingAvailabilityErrorSubstitutions?.time_limit,
        })}
      />
    )
  }

  if (
    bookingAvailabilityErrorCode ===
    BookingAvailabilityError.BOOKING_AVAILABILITY_MANAGER_EXCEPTION_ERROR_003
  ) {
    return (
      <AlertWrapper
        intent="warning"
        message={t('insertPeriod.alerts.003', {
          offset: bookingAvailabilityErrorSubstitutions?.offset,
        })}
      />
    )
  }

  if (
    bookingAvailabilityErrorCode ===
    BookingAvailabilityError.BOOKING_AVAILABILITY_MANAGER_EXCEPTION_ERROR_004
  ) {
    return (
      <AlertWrapper intent="warning" message={t('insertPeriod.alerts.004')} />
    )
  }

  if (
    bookingAvailabilityErrorCode ===
    BookingAvailabilityError.BOOKING_AVAILABILITY_MANAGER_EXCEPTION_ERROR_005
  ) {
    return (
      <AlertWrapper
        intent="warning"
        message={t('insertPeriod.alerts.005', {
          minDays: bookingAvailabilityErrorSubstitutions?.min_days,
        })}
      />
    )
  }

  if (
    bookingAvailabilityErrorCode ===
    BookingAvailabilityError.BOOKING_AVAILABILITY_MANAGER_EXCEPTION_ERROR_006
  ) {
    return (
      <AlertWrapper
        intent="warning"
        message={t('insertPeriod.alerts.006', {
          maxDays: bookingAvailabilityErrorSubstitutions?.max_days,
        })}
      />
    )
  }

  if (
    bookingAvailabilityErrorCode ===
    BookingAvailabilityError.TICKET_OVERBOOKING_EXCEPTION_ERROR_001
  ) {
    return (
      <AlertWrapper
        intent="warning"
        message={t('insertPeriod.alerts.TICKETS_OVERBOOKING_001')}
      />
    )
  }

  if (
    bookingAvailabilityErrorCode === BookingAvailabilityError.SOLD_OUT ||
    isSoldOut
  ) {
    return (
      <AlertWrapper
        intent="warning"
        message={t('insertPeriod.alerts.SOLD_OUT')}
      />
    )
  }

  if (searchParams.has('createCartError')) {
    const error = searchParams.get('createCartError')

    return (
      <AlertWrapper
        intent="critical"
        message={t(`insertPeriod.alerts.${error}`, {
          defaultValue: t('insertPeriod.alerts.genericError'),
        })}
      />
    )
  }

  return (
    <AlertWrapper
      intent="critical"
      message={t('insertPeriod.alerts.genericError')}
    />
  )
}

function AlertWrapper(props: {
  intent: 'neutral' | 'success' | 'warning' | 'critical' | 'danger'
  message: React.ReactNode
}) {
  return (
    <Alert className="mb-4 flex whitespace-normal" intent={props.intent}>
      <ExclamationMark className="size-6 shrink-0 text-yellow-600" />
      {props.message}
    </Alert>
  )
}
